import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { ListRequest } from "@/api/models/ListRequest";
import { ProductAddRequest } from "@/api/models/product/ProductAddRequest";
import { ProductUpdateRequest } from "@/api/models/product/ProductUpdateRequest";
import { ProductListResponse } from "@/api/models/product/ProductListResponse";

export class ProductService {
  public static Add(body: ProductAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/product",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/product",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/product/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: ProductUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/product",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<ProductListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/product",
      body: body,
    });
  }
}
